/* src/app/shared/timesheet/table/mobile/mobile-timesheet-table.component.scss */
#mobile-timesheet-table-container {
  width: 90%;
  margin: auto;
}
#mobile-timesheet-table-container > mat-card {
  margin: 2rem 0;
}
#task-header {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#holiday-container {
  padding: 1rem 0;
}
#holiday-container button {
  display: block;
  margin-left: auto;
}
.project-autocomplete-form {
  width: 100%;
}
#mobile-progress-indicator {
  margin-left: auto;
  max-width: 200px;
  align-self: flex-end;
}
.mat-expansion-panel-header-title,
.mat-expansion-panel-header-description {
  flex: 1;
}
#week-accordion {
  position: relative;
  z-index: 1;
}
.mobile-week-selector-container {
  width: 100%;
  text-align: center;
  transform: translateY(-15%);
}
.mobile-week-selector-container mat-icon {
  animation: bounce ease-in-out 2s infinite;
}
@keyframes bounce {
  0%, 100% {
    transform: translate(0, 5px);
  }
  50% {
    transform: translate(0, 0);
  }
}
.task-box {
  max-width: calc(100vw - 100px);
}
.task-box .mat-mdc-standard-chip {
  max-width: 100% !important;
}
:host ::ng-deep .task-option.mat-mdc-standard-chip .mdc-evolution-chip__cell--primary,
:host ::ng-deep .task-option.mat-mdc-standard-chip .mdc-evolution-chip__action--primary,
:host ::ng-deep .task-option.mat-mdc-standard-chip .mat-mdc-chip-action-label {
  overflow: hidden;
}
/*# sourceMappingURL=mobile-timesheet-table.component.css.map */
